module.exports = __webpack_public_path__ + "static/Algemene voorwaarden Sharewater-0449b7986d73163b4aefd6e7d8ceb9eb.pdf";